export interface WicketAdminUserDataChangelog {
  data_name: string;
  change_to: any;
  created_at: string;
  operation_type: string;
  updater_type: string;
  updater_id: string | null;
}
